import { useNavigate, useParams } from "react-router-dom"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"
import { apiRoute, ENUM_APP_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl, SALE_PUR_ENTRY_TYPE } from "../../constants/enum";
import { useCallback, useEffect, useMemo, useState, useTransition } from "react";
import { Card, Select, Autocomplete, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, AutocompleteItem, Button, SelectItem, Input, CardBody, Chip, colors, RadioGroup, Radio, form } from "@nextui-org/react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faClose, faListCheck, faPlus, faSave, faSquareXmark, faTrash, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { useSelector } from "react-redux";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from "react-toastify";
import { Drawer } from "@mui/material";
import { fun_calNet_Amt, fun_calTcs_Amt, fun_calTds_Amt, fun_calTotalTax } from "../creditdebitnote/enum";
import { calculateTotal } from "../../Utility/utility";
import { addDays } from "date-fns";
import { ChallanList, InwardItemsEntry } from "../index.js"


// const ENUM_TRADE_OF = [
//     { key: "C", value: "Gray" },
//     { key: "Y", value: "Yarn" }
// ]
const ENUM_TRADE_TYPE = [
    { value: "RD" },
    { value: "URD" },
    { value: "OGS" }
]

const CreatePurchaseEntry = () => {
    const { compCode, appType, compState, groupCode, isMultipleCompany ,startDate,endDate} = useSelector((state) => state.company)
    const { detailParams, isNewEntry } = useSelector((state) => state.purchaseEntry)
    const { user } = useSelector((state) => state.auth)
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [openDrawer, setOpenDrawer] = useState(false);
    let [isStPerDisable, setIsStPerDisable] = useState(false)
    const [deletedItemRows, setDeletedItemRows] = useState([])
    let [setTcsPer, setSetTcsPer] = useState(0)
    let [setTdsPer, setSetTdsPer] = useState(0)
    const [selTradeOf, setSelTradeOf] = useState("C")
    const [isManualEntry, setIsManualEntry] = useState(false)
    const [allowTaka, setAllowTaka] = useState(0)
    let [selInwardItemsData, setSelInwardItemsData] = useState([])
    let [currentTaKaList, setCurrentTaKaList] = useState()
    let [isPartyChangeOrder, setIsPartyChangeOrder] = useState(false)
    const navigate = useNavigate();
    const [modeSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")
    const { typeid } = useParams();
    const [selectedChallan, setSelectedChallan] = useState("")
    const [partyChallanData, setPartyChallanData] = useState([])
    let [msg, setMsg] = useState("")
    const [JvTrnData, setJvTrnData] = useState({
        trnNo: 0,
        tdsJvTrnNo: 0,
        tcsJvTrnNo: 0,
        excJvTrnNo: 0,
        excSedJvTrnNo: 0,
        excAedJvTrnNo: 0,
    })


    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modeSetting.getMultiModSetting,
        queryKey: "fetchModSetting",
    })
    const onSuccessChalData = (data) => {

        if (selectedChallan != "" && selectedChallan != "0") {
            // setSelChallanDetail(data)
            setOpenDrawer(false)
            //if(rows && rows.length<=0){
            let _id = rows.length + 1
            let newRows = {
                id: _id, objOrderNo: [],
                ...initialRow, [RowsField.itemCode]: data[0].Item_Code,
                [RowsField.itemDetail]: data[0].Item_Desc, [RowsField.meter]: data[0].Meter,
                [RowsField.rate]: data[0].Rate, [RowsField.stPer]: data[0].StPer,
                [RowsField.weight]: data[0].Weight, [RowsField.unit]: data[0].Item_unit,
                [RowsField.astPer]: data[0].AstPer,
                [RowsField.amount]: data[0].Amount, [RowsField.pcs]: data[0].Nos
            }

            let UpData = newRows
            //if (formData.tradeType != "") {
            const getData = funSetGst([newRows], data[0].Item_Code, 0, formData.tradeType, true)
            if (getData && getData.length > 0) {
                UpData = {
                    ...newRows, [RowsField.astAmt]: getData[0].astAmt,
                    [RowsField.stAmt]: getData[0].stAmt,
                    [RowsField.netAmt]: getData[0].netAmt,
                    [RowsField.discPer]: getData[0].discPer,
                    [RowsField.discAmt]: getData[0].discAmt
                }
                //console.log(UpData, "ji")

            }
            setRows([UpData])

            //  }

            //}
        }
        else {
            if (data && data.length > 0) {
                setPartyChallanData(data)
                setOpenDrawer(true)
            }
            else {
                if (formData.deliveryId != "" && formField.deliveryId != null) {
                    toast.error("No Data Found", {
                        "position": "top-center"
                    })
                }
            }
        }

    }
    const { isError: isErrorChal, data: challanData = [], mutate: filterChallan } = usePost({
        url: apiRoute.transaction.PurchaseEntry.challanData,
        queryKey: "fetchChallanData",
        onSuccessTasks: onSuccessChalData
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.transaction.PurchaseEntry.fetchEntryDetail,
        queryKey: "PurchseEntryDetail",
    })
    const funFilterChalData = (action, partyid, transid) => {

        filterChallan({
            data: {
                action: action,
                compcode: compCode.join(','),
                transid: transid,
                partyid: partyid,
                billid: 0,
                tradeof: selTradeOf,
                billtype: 'P'
            }
        })
    }
    //console.log(detailParams)
    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        const params = [SALE_PUR_ENTRY_TYPE.GrayCloth, SALE_PUR_ENTRY_TYPE.Yarn, SALE_PUR_ENTRY_TYPE.Millgin, SALE_PUR_ENTRY_TYPE.General]
        if (!params.includes(String(typeid)))
            navigate(linksUrl.dashboard.tradingDashboard)


        if (typeid && typeid != "" && startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_modName = ''
            let t_typeid = typeid.toLowerCase()
            if (t_typeid == SALE_PUR_ENTRY_TYPE.GrayCloth.toLowerCase()) {
                t_tradeof = 'C'
                t_entryLabel = "Gray Cloth Purchase"
                t_modName = [ENUM_MOD_NAME.GrayPurchaseInvoice, ENUM_MOD_NAME.GrayPurchaseChallan]
            }
            else if (t_typeid == SALE_PUR_ENTRY_TYPE.Yarn.toLowerCase()) {
                t_tradeof = 'Y'
                t_entryLabel = "Yarn Purchase"
                t_modName = [ENUM_MOD_NAME.YarnPurchaseInvoice, ENUM_MOD_NAME.YarnPurchaseChallan]
            }
            else if (t_typeid == SALE_PUR_ENTRY_TYPE.Millgin.toLowerCase()) {
                t_tradeof = 'M'
                t_entryLabel = "Millgin Purchase"
                t_modName = [ENUM_MOD_NAME.MillginPurchaseInvoice]
            }
            else if (t_typeid == SALE_PUR_ENTRY_TYPE.General.toLowerCase()) {
                t_tradeof = 'G'
                t_entryLabel = "General Purchase"
                t_modName = [ENUM_MOD_NAME.GeneralPurchaseInvoice]
            }
            setSelTradeOf(t_tradeof)
            setEntryLabel(t_entryLabel)

            filterModSetting({
                data: {
                    page_mod: t_modName.join(','),
                    master_mod: ENUM_MOD_NAME.general
                }
            })
            filterMatserData({
                data: {
                    compcode: compCode.join(","),
                    trade_of: String(t_tradeof),
                    bill_type:'P'
                }
            })
            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, bill_type,bill_no } = detailParams
                funGetDetail({
                    data: {
                        compcode: comp_code,
                        transactionid: transaction_id,
                        billtype: bill_type,
                        billno:bill_no
                    }
                })
            }
        }
    }, [typeid,startDate,endDate])

    useEffect(() => {
        let modData = modSetting && modSetting?.pageData ? modSetting?.pageData : [];
        let yarnChalModData = []
        let mod_inv = ENUM_MOD_NAME.GrayPurchaseInvoice
        let mod_chal = ENUM_MOD_NAME.GrayPurchaseChallan
        if (selTradeOf == 'Y') {
            mod_inv = ENUM_MOD_NAME.YarnPurchaseInvoice
            mod_chal = ENUM_MOD_NAME.YarnPurchaseChallan
        }
        if (modSetting && modSetting?.pageData && modSetting?.pageData.length > 0) {
            modData = modSetting?.pageData.filter(ele => ele.ModName == mod_inv)
            yarnChalModData = modSetting?.pageData.filter(ele => ele.ModName == mod_chal)
        }

        // const modData=modSetting&& modSetting?.length>0?modeSetting.filter
        setModSettingParams({
            Visibility: {
                [RowsField.orderNo]: false, //getModVisiblity(ENUM_MOD_PARAMETER.PurchaseEntry.GridOrder, modData) ?? false,
                [RowsField.itemDetail]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.GridItemDet, modData) ?? false,
                [RowsField.cut]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.GridCut, modData) ?? false,
                [RowsField.meter]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.Meter, modData) ?? false,
                [RowsField.weight]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.Weight, modData) ?? false,
                [RowsField.discPer]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.Discount, modData) ?? false,
                [RowsField.discAmt]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.Discount, modData) ?? false,
                [RowsField.color]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.GridColor, modData) ?? false,
                [RowsField.subCat]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.GridSubCat, modData) ?? false,
                [RowsField.marko]: getModVisiblity(ENUM_MOD_PARAMETER.gridColumn.GridMarko, modData) ?? false,
                "autoChallanEntry": getModVisiblity(ENUM_MOD_PARAMETER.purchaseEntry.AutoChallanEntry, modData) ?? false,
                "tds": getModVisiblity(ENUM_MOD_PARAMETER.purchaseEntry.Tds, modData) ?? false,
                "cartonDetail": getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.CartonDetail, yarnChalModData) ?? false,
                "cartonNo": getModVisiblity(ENUM_MOD_PARAMETER.challanEntry.CartonNo, yarnChalModData) ?? false,
            },
            Mandatory: {
                [RowsField.orderNo]: false, //getModMandatory(ENUM_MOD_PARAMETER.saleEntry.GridOrder, modData) ?? false,
                [RowsField.meter]: getModMandatory(ENUM_MOD_PARAMETER.purchaseEntry.Meter, modData) ?? false,
                [RowsField.weight]: getModMandatory(ENUM_MOD_PARAMETER.purchaseEntry.Weight, modData) ?? false,
                "tcsCalc": getModMandatory(ENUM_MOD_PARAMETER.saleEntry.TcsCalc, modData) ?? false,
                // "tcsRate": getModMandatory(ENUM_MOD_PARAMETER.generalSetting.TcsRate, modData) ?? false,
                ///"tcsTurnOver": getModMandatory(ENUM_MOD_PARAMETER.generalSetting.TcsTurnover, modData) ?? false

            },
            Value: {
                "tcsRate": getModValue(ENUM_MOD_PARAMETER.generalSetting.TcsRate, modSetting?.masterData) ?? 0,
                "tcsTurnOver": getModValue(ENUM_MOD_PARAMETER.generalSetting.TcsTurnOver, modSetting?.masterData) ?? 0
            }
        })

    }, [modSetting])


    const toggleDrawer = (isOpen) => (event) => {
        // Close drawer if the event is a keyboard event and the key is 'Tab' or 'Escape'
        const e_type = event.type ?? ""
        if (e_type === 'keydown' && (e_type === 'Tab' || e_type === 'Escape')) {
            setOpenDrawer(false);
            return;
        }
        setOpenDrawer(isOpen);
    };
    //console.log(detail, "d")
    let gridData = []
    const formField = {
        transId: "transId",
        entryType: "entryType",
        tradeType: "tradeType",
        voucherNo: "voucherNo",
        challanNo: "challanNo",
        challanDate: "challanDate",
        billNo: "billNo",
        billDate: "billDate",
        acName: "acName",
        acId: "acId",
        partyName: "partyName",
        partyId: "partyId",
        vehicleNo: "vehicleNo",
        deliveryName: "deliveryName",
        deliveryId: "deliveryId",
        unitName: "unitName",
        unitId: "unitId",
        partyOrdNo: "partyOrdNo",
        transportId: "transportId",
        brokerId: "brokerId",
        itemName: "itemName",
        remarks: "remarks",
        tdsAc: "tdsAc",
        dueDays: "dueDays",
        dueDate: "dueDate",
        lrNo: "LrNo",
        lrDate: "lrDate"
        // eWayBillNo: "eWayBillNo",
        // eWayBillDate: "eWayBillDate",
        // irnNo: "irnNo",
        // ackNo: "ackNo",
        // ackDate: "ackDate",


    }

    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.transaction.PurchaseEntry.entryMasterData,
        queryKey: "fetchGrayStockMasterData",
        // onSuccessTasks: onSuccessMastData

    })

    const onSuccessGrayItem = (data) => {
        //toggleDrawer(true)
        setSelInwardItemsData(data)

    }
    const { isError: isErrorGrayitemData, data: inwardItemData = [], mutate: filterInwItemData } = usePost({
        url: apiRoute.transaction.PurchaseEntry.fetchEntryStock,
        queryKey: "fetchitemsData",
        onSuccessTasks: onSuccessGrayItem

    })

    const onSuccessTasks = (data) => {
        if (data)
            navigate(linksUrl.transaction.PurchaseEntry + typeid)
    }
    const { isError: isError, mutate: funInUpStock } = usePost({
        url: apiRoute.transaction.PurchaseEntry.add_update,
        queryKey: "InUpGrayStockMasterData",
        onSuccessTasks

    })
    const onSuccessVouno = (data) => {
        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.voucherNo]: data[0].new_vou_no,
                [formField.challanNo]: data[0].new_vou_no,
                [formField.billNo]: data[0].new_vou_no
            }))
        }
    }
    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.transaction.PurchaseEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: onSuccessVouno
    })
    //end
    const onSuccessOrderNo = (data) => {

        if (rows && rows.length > 0) {

            let index = 0;
            if (isPartyChangeOrder && data.length <= 0)
                index = selectedGridRowId && selectedGridRowId !== 'undefined' ? selectedGridRowId : 0;
            else
                if (data && data.length > 0)
                    index = rows.findIndex((ele) => ele.itemCode == data[0].Item_Code)

            let prev_OrdNo = rows[index][RowsField.orderNo]
            if (isPartyChangeOrder) {
                prev_OrdNo = ""
            }

            setRows((prevData) => {
                const newData = [...prevData];
                const updatedObj = { ...newData[index], objOrderNo: data, orderNo: prev_OrdNo };
                newData[index] = updatedObj;
                return newData;
            });

            // }
        }
    }
    const { data: orderNoData = [], mutate: filterOrderNo } = usePost({
        url: apiRoute.transaction.PurchaseEntry.fetchOrderList,
        queryKey: "getOrderNolIst",
        onSuccessTasks: onSuccessOrderNo


    })
    const funGetPcs = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selTradeOf == 'C') {
                if (selItemdata.find(el => el.CartonNo)) {
                    return selItemdata.length
                }
            }
            else {
                if (selItemdata.find(el => el.Pcs)) {
                    return calculateTotal({
                        data: selItemdata,
                        columnName: "Pcs",
                    })
                }
            }
            return 0
        }
        else
            return 0
    }
    const funGetWeight = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.Weight)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "Weight",
                })
            }
            return 0
        }
        else
            return 0
    }
    const funGetMeter = (selItemdata) => {
        if (selItemdata && selItemdata?.length > 0) {
            if (selItemdata.find(el => el.Meter)) {
                return calculateTotal({
                    data: selItemdata,
                    columnName: "Meter",
                })
            }
            return 0
        }
        else
            return 0
    }
    const funSetObjOrdNo = (partyId) => {

        if (rows && rows.length > 0)// && grpCompList && grpCompList.length > 0) 
        {
            for (let i = 0; i < rows.length; i++) {
                setSelectedGridRowId(i)
                funGetOrderNo(rows[i].itemCode, partyId)
            }
        }
    }
    const funCalAllAmount = (rowData, index, meter, pcs, weight) => {
        //console.log(rowData,"g",rows)
        let newRows = [...rows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let t_rate = newRows[index].rate ? newRows[index].rate : 0
        const t_unit = newRows[index].unit ? newRows[index].unit.toLowerCase() : ""
        const t_meter = meter > 0 ? meter : newRows[index].meter
        const t_pcs = pcs > 0 ? pcs : newRows[index].pcs
        const t_weight = pcs > 0 ? weight : newRows[index].weight

        if (t_unit != "") {
            if (t_unit == "mtr" || t_unit == "ltr") {
                t_Amount = Number(t_rate) * Number(t_meter)
            }
            else if (t_unit == "kgs" || t_unit == "grm")
                t_Amount = Number(t_rate) * Number(t_weight)
            else
                t_Amount = Number(t_rate) * Number(t_pcs)
        }
        else
            t_Amount = Number(t_rate) * Number(t_pcs)

        let t_discAmt = 0
        let t_stAmt = 0
        let t_astAmt = 0
        let t_netAmt = 0
        if (t_Amount > 0) {
            t_discAmt = (t_Amount * newRows[index].discPer) / 100

            t_stAmt = ((t_Amount - newRows[index].discAmt) *
                newRows[index].stPer) / 100

            t_astAmt =
                ((t_Amount - newRows[index].discAmt) *
                    newRows[index].astPer) /
                100
        }
        t_netAmt = fun_calNet_Amt(
            t_Amount,
            t_discAmt,
            t_stAmt,
            t_astAmt
        )
        return { amount: t_Amount, discAmt: t_discAmt, astAmt: t_astAmt, stAmt: t_stAmt, netAmt: t_netAmt }

    }
    const funGetOrderNo = (itemCode, partyId) => {
        if (modeSettingParams?.Visibility?.orderNo) {
            if (partyId != "") {
                filterOrderNo({
                    data: {
                        compcode: compCode.join(","),
                        item_code: itemCode,
                        pac_id: partyId,
                        bill_type: 'P',

                    }
                })
            }
            else {
                toast.error("Select Party ", {
                    "position": "top-center"
                })
            }
        }
    }

    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {
            gridData = detail?.itemDetail.map((item, i) => {
                return {
                    id: ++i,
                    //invType: item?.bill_type ?? "",
                    orderNo: item?.ord_no ?? "",
                    oldOrdNo: item?.ord_no ?? "",
                    itemCode: item?.item_code ?? "",
                    itemDetail: item?.item_det ?? "",
                    itemName: item?.item_desc ?? "",
                    unit: item?.item_unit ?? "",
                    pcs: item?.nos ?? 0,
                    cut: item?.cut ?? 0,
                    meter: item?.meter ?? 0,
                    weight: item?.weight ?? 0,
                    rate: item?.rate ?? 0,
                    amount: item?.amount ?? 0,
                    discPer: item?.discper ?? 0,
                    discAmt: item?.discamt ?? 0,
                    stPer: item?.stper ?? 0,
                    stAmt: item?.stamt ?? 0,
                    astPer: item?.astper ?? 0,
                    astAmt: item?.astamt ?? 0,
                    netAmt: item?.amount
                        ? fun_calNet_Amt(item.amount, item?.discamt, item?.stamt, item?.astamt)
                        : 0,
                    detailId: item?.detailid ?? 0,
                    objSelectedInwItem: [],
                    objOrderNo: [],

                }
            })
        }
    }
    const [rows, setRows] = useState([])

    const RowsField = {
        detailId: "detailId",
        orderNo: "orderNo",
        id: "id",
        itemCode: "itemCode",
        itemName: "itemName",
        itemDetail: "itemDetail",
        unit: "unit",
        rate: "rate",
        cut: "cut",
        amount: "amount",
        discPer: "discPer",
        pcs: "pcs",
        meter: "meter",
        weight: "weight",
        discPer: "discPer",
        discAmt: "discAmt",
        stPer: "stPer",
        stAmt: "stAmt",
        astPer: "astPer",
        astAmt: "astAmt",
        netAmt: "netAmt",
        objSelectedInwItem: "objSelectedInwItem"

    }
    const initialRow = {
        [RowsField.orderNo]: "",
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.itemDetail]: "",
        [RowsField.unit]: "",
        [RowsField.cut]: "",
        [RowsField.rate]: 0,
        [RowsField.amount]: 0,
        [RowsField.pcs]: 0,
        [RowsField.meter]: 0,
        [RowsField.weight]: 0,
        [RowsField.discPer]: 0,
        [RowsField.discAmt]: 0,
        [RowsField.stPer]: 0,
        [RowsField.stAmt]: 0,
        [RowsField.astPer]: 0,
        [RowsField.astAmt]: 0,
        [RowsField.netAmt]: 0,
        [RowsField.objSelectedInwItem]: [],
    }
    const itemGridHeadClass = "bill-grid-style"
    //fn to calculation of total tax section
    const total_disc = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmt",
            }),
        [rows]
    )
    const total_GSTtax = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "stAmt",
            }),
        [rows]
    )
    const total_SGSTtax = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "astAmt",
            }),
        [rows]
    )
    const gross_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "netAmt",
            }),
        [rows]
    )
    const funSetGst = (newRows, itemCode, index, tradeType, isReturnData) => {
        if (itemCode != null && itemCode.length > 0 && itemCode != "") {
            const tempData = masterData.itemMaster.filter((ele) => ele.Item_Code.toLowerCase() == itemCode.toLowerCase())

            if (tempData) {
                if (tempData.length > 0) {
                    let t_StPer = Number(tempData[0]?.STPer);
                    let t_AstPer = Number(tempData[0]?.ASTPer)
                    if (tradeType == "OGS") {
                        newRows[index].stPer = t_StPer + t_AstPer
                        newRows[index].astPer = 0;
                        t_StPer = t_StPer + t_AstPer
                        t_AstPer = 0;
                    }
                    else {
                        newRows[index].astPer = t_AstPer;
                        newRows[index].stPer = t_StPer;
                    }
                    let tempTot = 0;

                    tempTot =
                        ((newRows[index].amount - newRows[index].discAmt) *
                            t_StPer) /
                        100
                    newRows[index].stAmt = tempTot

                    tempTot =
                        ((newRows[index].amount - newRows[index].discAmt) *
                            t_AstPer) /
                        100
                    newRows[index].astAmt = tempTot

                    tempTot = fun_calNet_Amt(
                        newRows[index].amount,
                        newRows[index].discAmt,
                        newRows[index].stAmt,
                        newRows[index].astAmt
                    )
                    newRows[index].netAmt = tempTot
                }
            }

        }

        if (isReturnData)
            return newRows
        else
            setRows(newRows)
        // return newRows
    }

    const total_Tax = useMemo(() => fun_calTotalTax(total_GSTtax, total_SGSTtax), [rows])
    const total_TdsAmt = useMemo(() => fun_calTds_Amt(gross_Amount, setTdsPer), [rows, setTdsPer])
    const total_TcsAmt = useMemo(() => fun_calTcs_Amt(net_Amount, setTcsPer), [rows, setTcsPer])
    //delete row from dynamic grid
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        setRows(updatedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }
    //end delete row from dynamic grid
    const handleInputChange = (rowId, e, name) => {

        let { value, id } = e.target
        let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rows]
        if (id == RowsField.itemDetail) newRows[index][id] = value
        else if (id == RowsField.rate) newRows[index][id] = value
        else if (id == RowsField.cut) newRows[index][id] = value
        else if (id == RowsField.weight) newRows[index][id] = value
        else if (id == RowsField.amount) newRows[index][id] = value
        else if (id == RowsField.meter) newRows[index][id] = value
        else if (id == RowsField.discPer) newRows[index][id] = value
        else if (id == RowsField.discAmt) newRows[index][id] = value
        else if (id == RowsField.stPer) newRows[index][id] = value
        else if (id == RowsField.stAmt) newRows[index][id] = value
        else if (id == RowsField.astPer) newRows[index][id] = value
        else if (id == RowsField.astAmt) newRows[index][id] = value
        else if (id == RowsField.pcs) newRows[index][id] = value
        else if (name == RowsField.orderNo) newRows[index][name] = value //select box not get id in e.targer

        if (
            id == RowsField.rate ||
            id == RowsField.pcs ||
            id == RowsField.discPer ||
            id == RowsField.stPer ||
            id == RowsField.astPer ||
            id == RowsField.weight ||
            id == RowsField.meter
        ) {

            const calData = funCalAllAmount(newRows, index, 0, 0, 0)
            newRows[index].amount = calData.amount
            newRows[index].discAmt = calData.discAmt
            newRows[index].stAmt = calData.stAmt
            newRows[index].astAmt = calData.astAmt
            newRows[index].netAmt = calData.netAmt
            funSetGst(newRows, newRows[index][RowsField.itemCode], index, formData.tradeType, false)

        }

        setRows(newRows)
    }
    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (
            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                size="sm"
                // label=""
                labelPlacement="outside"
                readOnly={is_readonly}
                placeholder={holder_text}
                //allow space in text box
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                value={row[input_id]}
                onChange={(e) => handleInputChange(row.id, e, "")}
                className="max-w-xs mt-1"
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }
    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <strong>
                    <FontAwesomeIcon
                        color="red"
                        className="cursor-pointer"
                        onClick={() => handleDeleteRow(row.id)}
                        icon={faSquareXmark}
                    ></FontAwesomeIcon>
                </strong>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {row.itemCode}
            </div>)

            //renderInputCell(row, RowsField.acYear, "text", false, "Ac.Year", true),
        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            width: 300,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    <Autocomplete
                        isRequired
                        size="sm"
                        color={"success"}
                        id={RowsField.itemName}
                        eventResizeFeature={true}
                        selectionMode="single"
                        showScrollIndicators={true}
                        placeholder="--Select--"
                        className="max-w-23"
                        menuTrigger={"input"}
                        isClearable={false}
                        isLoading={isLoadingData}
                        isVirtualized
                        defaultItems={
                            masterData && masterData.itemMaster ? masterData?.itemMaster : []
                        }
                        onSelectionChange={(e) =>
                            handleAutoCompleteChange(e, row.id)
                        }
                        //onChange={handleFormSelectionChange}
                        selectedKey={row.itemCode}
                    >
                        {(item) => (
                            <AutocompleteItem
                                key={item.Item_Code}
                            >
                                {item.Item_Code + "(" + item.Item_Desc + ")"}
                            </AutocompleteItem>
                        )}
                    </Autocomplete>
                    {
                        selTradeOf == 'C' &&
                            modeSettingParams?.Visibility?.cartonDetail
                            ?
                            <Chip size="sm" color="danger" radius="sm"
                                className="ml-3 cursor-pointer" variant="shadow"
                                onClick={() => handleItems(row.id)}>View Taka</Chip>
                            : ""}
                    {selTradeOf == 'Y' &&
                        modeSettingParams?.Visibility?.cartonDetail
                        ? !modeSettingParams?.Visibility?.autoChallanEntry ?
                            <Chip size="sm" color="danger" radius="sm"
                                className="ml-3 cursor-pointer" variant="shadow"
                                onClick={() => handleItems(row.id)}>View Carton</Chip>
                            : "" : ""}
                </div>
            ),
        },

        {
            field: RowsField.itemDetail,
            headerName: "Item Detail",
            width: 150,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.itemDetail, "text", false, "Item Detail", false, "", ""),
        },
        {
            field: RowsField.orderNo,
            headerName: "Order No",
            width: 180,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (

                <div className="mt-1">

                    <Select
                        isVirtualized
                        id={RowsField.orderNo}
                        placeholder="--select--"
                        size="sm"
                        //label={"Select Order No"}
                        selectionMode="single"
                        className="mt-1"
                        isRequired={modeSettingParams?.Visibility[RowsField.orderNo] ? modeSettingParams?.Mandatory[RowsField?.orderNo] : false} //getModMandatory(ENUM_MOD_PARAMETER.GridOrder, modSetting)
                        value={row[RowsField?.orderNo]}
                        items={row.objOrderNo ? row.objOrderNo : []}
                        variant="flat"
                        color="warning"
                        onChange={(e) => handleInputChange(row.id, e, RowsField.orderNo)}
                        classNames={{
                            label: "text-xs text-black font-bold",
                        }}
                        selectedKeys={[String(row[RowsField.orderNo])]}
                    >
                        {(list) => {
                            return (
                                <SelectItem key={list.Order_No}>
                                    {list.Order_No}
                                </SelectItem>
                            );
                        }}
                    </Select>
                </div>
            )
        },
        {
            field: RowsField.unit,
            headerName: "Unit",
            width: 80,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {row[RowsField.unit]}
                </div>)
        },
        {
            field: RowsField.cut,
            headerName: "Cut",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.cut, "text", false, "", false, "", ""),
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.pcs, "number",
                    selTradeOf == 'C' && modeSettingParams?.Visibility?.takaView ? true : false, "", false, "", ""),
        },
        {
            field: RowsField.meter,
            headerName: "Meter",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.meter, "number",
                    selTradeOf == 'C' && modeSettingParams?.Visibility?.takaView ? true : false
                    , "", false, "", ""),
            //!modeSettingParams?.Visibility?.takaView && isManualEntry
            //getModVisiblity(ENUM_MOD_PARAMETER.InwardTakaView, modSetting)
        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.weight, "number",
                    selTradeOf == 'C' ? !modeSettingParams?.Visibility?.takaView && isManualEntry ? false : true : false
                    , "", false, "", ""),
            //getModVisiblity(ENUM_MOD_PARAMETER.InwardTakaView, modSetting)
        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.rate, "number", false, "", false, "", ""),
        },
        {
            field: RowsField.amount,
            headerName: "Amount",
            width: 130,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.amount]}
                </div>)
        },
        {
            field: RowsField.discPer,
            headerName: "Disc %",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.discPer, "number", false, "", false),
        },
        {
            field: RowsField.discAmt,
            headerName: "Disc Amount",
            width: 100,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.discAmt, "number", true, "", false),
        },
        {
            field: RowsField.stPer,
            headerName: !isStPerDisable ? "CGST %" : "IGST %",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.stPer, "number", false, "", false),
        },
        {
            field: RowsField.stAmt,
            headerName: !isStPerDisable ? "CGST" : "IGST",
            headerClassName: itemGridHeadClass,
            width: 120,
            headerAlign: "center",
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.stAmt, "number", true, "", false),
        },
        {
            field: RowsField.astPer,
            headerName: "SGST%",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.astPer, "number", false, "", false),
        },
        {
            field: RowsField.astAmt,
            headerName: "SGST",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.astAmt, "number", true, "", false),
        },
        {
            field: RowsField.netAmt,
            headerName: "Net Amount",
            width: 150,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) =>
                renderInputCell(row, RowsField.netAmt, "number", true, "", false),

        },


    ]
    const funSetTradeType = (partyId) => {
        let t_tradeType = formData.tradeType
        if (compState && compState?.trim() != "") {
            const tempData = masterData.acMaster.filter((ele) => ele.Party_Id == partyId)
            if (tempData && tempData?.length > 0) {
                if (tempData[0]?.ADD_6.trim() != "") {
                    if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
                        t_tradeType = "RD"
                    else
                        t_tradeType = "OGS"
                }
                else
                    t_tradeType = "URD"
            }
            if (t_tradeType == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
            else setIsStPerDisable(true)

        }
        return t_tradeType
    }
    const handleAutoCompleteChange = (value, rowid, name) => {

        // const value=e
        // const { id, name } = data;
        let t_tradeType = formData.tradeType;
        let t_deliveryId = formData.deliveryId;


        if (name == formField.partyId || name == formField.deliveryId || name == formField.unitId || name == formField.acId) {
            if (name == formField.acId) {
                generateVouNo({
                    data: {
                        comp_code: compCode.join(","),
                        vou_type: 'P',
                        p_id: value,
                        trade_of: selTradeOf,
                        vou_of: '',
                        start_date:dayjs(startDate).format("YYYY-MM-DD"),
                        end_date:dayjs(endDate).format("YYYY-MM-DD"),
                    }
                })
            }
            else if (name == formField.deliveryId) {
                funFilterChalData('CHALLAN_DATA', value, null)
            }
            else if (name == formField.partyId) {
                setIsPartyChangeOrder(true)
                t_tradeType = funSetTradeType(value)
                t_deliveryId = value

                if (rows && rows.length > 0)// && grpCompList && grpCompList.length > 0)
                    funSetObjOrdNo(value)

                rows.map((element, index) => {
                    funSetGst(rows, element.itemCode, index, t_tradeType, false)
                })


            }
            if (name == formField.partyId) {
                setFormData({
                    ...formData,
                    [name]: value,
                    tradeType: t_tradeType,
                    [formField.deliveryId]: t_deliveryId
                })
            }
            else {
                setFormData({
                    ...formData,
                    [name]: value,
                })
            }
        }
        else {
            if (rows.find((ele) => ele.itemCode == value)) {
                toast.error("Item already added", {
                    "position": "top-center"
                })
                const index = rows.findIndex((ele) => ele.id == rowid)
                let newRow = [...rows]
                newRow[index].itemCode = ""
                newRow[index].itemName = ""
                newRow[index].unit = ""
                setRows(newRow)
            }
            else {
                setIsPartyChangeOrder(false)
                const index = rows.findIndex((ele) => ele.id == rowid)
                setSelectedGridRowId(index)

                funGetOrderNo(value, formData[formField.partyId]) //getorderno by item
                const tempdata = masterData.itemMaster
                const itemData = tempdata.filter((ele) => ele.Item_Code == value)

                let newRow = [...rows]
                funSetGst(newRow, value, index, formData.tradeType, false)

                if (itemData && itemData.length > 0) {
                    newRow[index].itemCode = itemData[0].Item_Code
                    newRow[index].itemName = itemData[0].Item_Desc
                    newRow[index].unit = itemData[0].Item_Unit
                    newRow[index].orderNo = ""
                    setRows(newRow)
                }
                setMsg("")
            }
        }

    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.challanDate || key == formField.dueDate || key == formField.billDate)
            acc[key] = new Date()
        else if (key == formField.lrDate)
            acc[key] = null
        else acc[key] = ""
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {

        Row0: [{
            id: formField.voucherNo,
            name: formField.voucherNo,
            placeholder: "Voucher No",
            type: ENUM_INPUT_TYPE.text,
            size: "sm",
            label: "",
            isrequired: true,

        },

        {
            id: formField.tradeType,
            name: formField.tradeType,
            placeholder: "Trade Type",
            type: ENUM_INPUT_TYPE.select,
            size: "sm",
            label: "",
            data: ENUM_TRADE_TYPE,
            itemkey: "value",
            itemvalue: "value",
            isrequired: false,
        }
        ],
        Row1: [{
            id: formField.acId,
            name: formField.acId,
            placeholder: "A/C Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.grayMaster ? masterData?.grayMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,

        }, {
            id: formField.partyId,
            name: formField.partyId,
            placeholder: "Trade Party Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,

        }],
        Row3: [{
            id: formField.deliveryId,
            name: formField.deliveryId,
            placeholder: "Challan Party",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,

        }
            , {
            id: formField.unitId,
            name: formField.unitId,
            placeholder: "Unit Name",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData && masterData?.unitMaster ? masterData?.unitMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,

        }],
        Row5: [
            {
                id: formField.challanNo,
                name: formField.challanNo,
                placeholder: "Challan No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {
                id: formField.challanDate,
                name: formField.challanDate,
                placeholder: "Challan Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,

            }
        ],
        Row6: [
            {
                id: formField.billNo,
                name: formField.billNo,
                placeholder: "Bill No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {
                id: formField.billDate,
                name: formField.billDate,
                placeholder: "Bill Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,

            }
        ],
        Row7: [{
            id: formField.brokerId,
            name: formField.brokerId,
            placeholder: "Broker",
            type: ENUM_INPUT_TYPE.select,
            size: "sm",
            label: "",
            data: masterData && masterData?.brokerMaster ? masterData?.brokerMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,

        },
        {
            id: formField.transportId,
            name: formField.transportId,
            placeholder: "Transport",
            type: ENUM_INPUT_TYPE.select,
            size: "sm",
            label: "",
            data: masterData && masterData?.transMaster ? masterData?.transMaster : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,

        },
        ],
        Row8: [
            {
                id: formField.vehicleNo,
                name: formField.vehicleNo,
                placeholder: "Vehicle No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            }
        ],
        Row9: [
            {
                id: formField.lrNo,
                name: formField.lrNo,
                placeholder: "LR No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,

            },
            {
                id: formField.lrDate,
                name: formField.lrDate,
                placeholder: "LR Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: false,

            }
        ]
    }

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        //const req_OrderNO = getModMandatory(ENUM_MOD_PARAMETER.GridOrder, modSetting)
        /// const req_Meter = getModMandatory(ENUM_MOD_PARAMETER.Meter, modSetting)
        if (rows.length > 0) {
            for (let i = 0; i < rows.length; i++) {
                // no = i + 1
                //if ((req_OrderNO && (rows[i].orderNo == "" || rows[i].orderNo == "0")) 
                if (rows[i].pcs == "" || rows[i].pcs == "0") {
                    if (!msg.includes("Pcs"))
                        msg = msg + "  Pcs ,";
                    no = 1
                }
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }


    const [errors, setErrors] = useState({})

    const validateForm = useCallback(() => {
        const newErrors = {}

        // Validate username
        if (formData[formField.voucherNo].trim() == "") {
            newErrors[formField.voucherNo] = "Voucher No is required"
        }
        if (formData[formField.acId] == null || formData[formField.acId]?.trim() == "" || formData[formField.acId] == "0") {
            newErrors[formField.acId] = "Acoount Name is required"
        }

        if (formData[formField.partyId] == null || formData[formField.partyId]?.trim() == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name is required"
        }
        if (formData[formField.deliveryId] == null || formData[formField.deliveryId]?.trim() == "" || formData[formField.deliveryId] == "0") {
            newErrors[formField.deliveryId] = "Delivery Name is required"
        }

        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }, [formData])


    const handleSubmit = (e) => {
        e.preventDefault()
        const grid_msg = ValidateGrid();
        const validate_form = validateForm();

        if (grid_msg == "" && validate_form) {
            let rowsData = rows
            
            //        //// const delTaka = ele.objSelectedTaka.filter(ele => ele.isDeleted == true).map(ele => ele.TakaId)
            let tot_Nos = 0
            let tot_Mtr = 0
            let tot_weight = 0
            rows.map((ele) => {
                tot_Nos += ele?.pcs ? Number(ele?.pcs) : 0
                tot_Mtr += ele?.meter ? parseFloat(ele?.meter) : 0
                tot_weight += ele?.weight ? parseFloat(ele?.weight) : 0
            })

            funInUpStock({
                data: {
                    isManualEntry: isManualEntry,
                    item_list: rowsData,
                    deleteditem_list: deletedItemRows,
                    rec_status: !isNewEntry ? 1 : 2, //2 for insert and 1 for update entry
                    trans_id: formData.transId,
                    comp_code: compCode.join(","),
                    ac_id: formData.acId,
                    party_id: formData.partyId,
                    del_id: formData.deliveryId,
                    unit_id: formData.unitId,
                    vou_no: formData.voucherNo,
                    nos: tot_Nos,
                    total_meter: tot_Mtr,
                    total_weight: tot_weight,
                    entry_type: formData.entryType,
                    challan_no: formData.challanNo,
                    challan_date: formData.challanDate,
                    bill_no: formData.billNo,
                    bill_date: formData.billDate,
                    trade_type: formData.tradeType,
                    broker_id: formData.brokerId,
                    trade_of: selTradeOf,
                    transport_id: formData.transportId,
                    vehicle_no: formData.vehicleNo,
                    gross_amt: gross_Amount,
                    total_gst: total_GSTtax,
                    total_sgst: total_SGSTtax,
                    disc_amt: total_disc,
                    net_amt: net_Amount,
                    tds_per: setTdsPer && setTdsPer != "" ? setTdsPer : 0,
                    tds_amt: total_TdsAmt,
                    tds_acid: formData.tdsAc,
                    tcs_per: setTcsPer && setTcsPer != "" ? setTcsPer : 0,
                    tcs_amt: total_TcsAmt,
                    remark: formData.remarks,
                    due_days: formData.dueDays != "" ? formData.dueDays : 0,
                    lr_no: formData.lrNo,
                    lr_date: formData.lrDate,
                    login_userid: user.username,
                    jv_trn_data: JvTrnData,
                    // eway_bill_data: eWayBillDetail
                }
            })
        }
        else {
            toast.error(grid_msg, {
                "position": "top-center"
            })
        }

    }
    //console.log(detail, "gh")
    useEffect(() => {
        if (!isNewEntry) {
            if (rows && rows.length > 0 && detail && detail?.itemData &&
                detail?.itemData.length > 0) {
                funSetObjOrdNo(detail.itemData[0]?.party_id)
            }
        }
    }, [modSetting])
    //grpCompList

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0)
            setRows(gridData)
        if (
            !isNewEntry &&
            detail &&
            detail?.itemData &&
            detail?.itemData.length > 0
        ) {
            // funSetObjOrdNo(detail.itemData[0]?.party_id)
            setSetTcsPer(detail.itemData[0].tcsper)
            setSetTdsPer(detail.itemData[0].tdsper)
            setSelTradeOf(detail.itemData[0]?.trade_of)
            if (detail.itemData[0]?.trade_type == "URD" || detail.itemData[0]?.trade_type == "RD") setIsStPerDisable(false)
            else setIsStPerDisable(true)

            setJvTrnData({
                trnNo: detail?.itemData[0]?.trn_no ?? 0,
                tdsJvTrnNo: detail?.itemData[0]?.tdsjvtrnno ?? 0,
                tcsJvTrnNo: detail?.itemData[0]?.tcsjvtrnno ?? 0,
                excAedJvTrnNo: detail?.itemData[0]?.excaedjvtrnno ?? 0,
                excSedJvTrnNo: detail?.itemData[0]?.excsedjvtrnno ?? 0,
                excJvTrnNo: detail?.itemData[0]?.excjvtrnno ?? 0
            })

            setFormData({
                transId: detail.itemData[0]?.TransactionId ?? "",
                challanNo: detail.itemData[0]?.chal_no ?? "",
                voucherNo: detail.itemData[0]?.vou_no ?? "",
                challanDate: detail.itemData[0]?.chal_date ?? "",
                billNo: detail.itemData[0]?.bill_no ?? "",
                billDate: detail.itemData[0]?.bill_date ?? "",
                orderNo: detail.itemData[0]?.bill_no ?? "",
                // acName: detail.itemData[0]?.account_name ?? "",
                acId: detail.itemData[0]?.account_id ?? "",
                // partyName: detail.itemData[0]?.party_name ?? "",
                partyId: detail.itemData[0]?.party_id ?? "",
                entryType: detail.itemData[0]?.entry_type ?? "",
                vehicleNo: detail.itemData[0]?.veh_no ?? "",
                // deliveryName: detail.itemData[0]?.delivery_name ?? "",
                deliveryId: detail.itemData[0]?.d_id ?? "",
                // unitName: detail.itemData[0]?.unit_name ?? "",
                unitId: detail.itemData[0]?.unit_id ?? "",
                partyOrdNo: "",
                transportId: detail.itemData[0]?.tac_id ?? "",
                brokerId: detail.itemData[0]?.br_id ?? "",
                itemName: "",
                dueDays: detail.itemData[0]?.due_days ?? "",
                tradeType: detail.itemData[0]?.trade_type ?? "",
                tdsAc: detail.itemData[0]?.tds_account_id ?? "",
                remarks: detail.itemData[0]?.remark ?? "",
                dueDate: detail.itemData[0]?.due_date ??null,
                   // addDays((Date(detail.itemData[0]?.chal_date)), detail.itemData[0]?.due_days)
                   // : detail.itemData[0]?.chal_date,
                lrNo: detail.itemData[0]?.lr_no ?? "",
                lrDate: detail.itemData[0]?.lr_date ?? null


            })

        } //set data on edit
    }, [detail])

    const handleFormSelectionChange = (e, type) => {
        let val = e;
        setFormData((prevData) => ({
            ...prevData,
            [type]: val,
        }))


    }
    //console.log(groupCode, "code",masterData)


    const handleChange = (e, id) => {
        const { name, value } = e.target
        let t_tradeType = formData.tradeType
        if (name == "tradeType") {
            if (value == "URD" || value == "RD") setIsStPerDisable(false)
            else setIsStPerDisable(true)

            // let newRows = [...rows]
            // rows.map((element, index) => {
            //     funSetGst(rows, element.itemCode, index, value)
            // })

        }
        let t_dueDate = formData[formField.dueDate]
        if (name == formField.dueDays) {
            if (formData[formField.challanDate] && formData[formField.challanDate] != ""
                && formData[formField.challanDate] != "Invalid Date" && value != "") {
                t_dueDate = addDays(formData[formField.challanDate], Number(value))
            }
        }
        if (name != "tradeType")
            setFormData({ ...formData, [name]: value, [formField.dueDate]: t_dueDate })

    }
    const handleDateChange = (newValue, name) => {
        if (name == formField.challanDate || name == formField.billDate || name == formField.lrDate) {
            let t_dueDate = formData[formField.dueDate]
            let t_dueDays = formData[formField.dueDays]
            if (name == formField.challanDate) {
                if (newValue && newValue != "" && newValue != "Invalid Date" && t_dueDays != "") {
                    t_dueDate = addDays(dayjs(newValue).format("YYYY-MM-DD"), Number(t_dueDays))
                }
                else
                    t_dueDate = newValue;
            }
            setFormData((prev) => {
                return {
                    ...prev,
                    [name]:
                        dayjs(newValue).format("YYYY-MM-DD"),
                    [formField.dueDate]: t_dueDate

                };
            });
        }
    }
    const handleClickPrev = () => {
        navigate(linksUrl.transaction.PurchaseEntry + typeid)
    }

    const handleSelectedInwardItem = (data) => {

        if (data && Object.keys(data).length > 0) {
            const selItem = data.item
            const delItem = isNewEntry ? [] : data.deletedItem.map(ele => String(ele.TakaId))
            const index = rows.findIndex((ele) => ele.id == selectedGridRowId)
            let tot_pcs = funGetPcs(selItem);//funGetYarnPcs(selItem)
            let tot_weight = funGetWeight(selItem)
            let tot_meter = funGetMeter(selItem)
            const calData = funCalAllAmount([], index, tot_meter, tot_pcs, tot_weight)
            console.log(tot_weight)
            // setSelGrayItemsData(data)
            const updateRow = {
                ...rows[index], objSelectedInwItem: selItem, delInwItemIds: delItem,
                pcs: tot_pcs, weight: tot_weight, meter: tot_meter,
                amount: calData.amount,
                discAmt: calData.discAmt,
                stAmt: calData.stAmt,
                astAmt: calData.astAmt,
                netAmt: calData.netAmt
            };
            const newRows = [...rows]
            newRows[index] = updateRow
            setRows(newRows)
        }

    }
    // console.log(selGrayItemsData,"gr")

    const handleItems = (id) => {
        if (modeSettingParams?.Visibility?.cartonDetail && !modeSettingParams?.Visibility?.autoChallanEntry) {
            const index = rows.findIndex((ele) => ele.id == id)


            if (rows[index][RowsField.itemCode] != "" && rows[index][RowsField.itemCode] != "0") {
                setMsg("")
                if ((rows[index]?.objSelectedInwItem && rows[index].objSelectedInwItem.length <= 0) ||
                    (rows[index]?.objSelectedInwItem[0].Item_Code != rows[index][RowsField.itemCode])) {
                    //console.log(index, rows[index][RowsField.itemCode])
                    
                    filterInwItemData({
                        data: {
                            compcode: compCode.join(","),
                            item_code: rows[index][RowsField.itemCode],
                            chal_no: isNewEntry ? null : formData.challanNo,
                            action: isNewEntry ? "NEWDATA" : "UPDATEDATA",
                            bill_type: 'P',
                            trade_of: selTradeOf

                        }
                    })
                    // setOpenDrawer(true)
                }
                else {

                    setSelInwardItemsData(rows[index].objSelectedInwItem)

                    // const cur_Taka = rows.map(ele => ele.objSelectedInwItem.filter(item => item.isAdded == 1))
                    // let selItems = []
                    // for (let i = 0; i < cur_Taka.length; i++) {
                    //     selItems = [...selItems, ...cur_Taka[i]]
                    // }
                    // setCurrentTaKaList(selItems)//check duplicate taka in current list when multiple item sleected
                    // setOpenDrawer(true)
                }
                // }
                setSelectedGridRowId(id)
                setOpenDrawer(true)
            }
            else {
                setMsg("Select Item")
                toast.error("Select Item", {
                    "position": "top-center"
                })
            }
        }

    }
    const handleAddRow = () => {
        const newRow = { id: rows.length + 1, ...initialRow, objOrderNo: [] }
        setRows([...rows, newRow])
    }
    const handleShowChallan = () => {
        if (formData.deliveryId != "") {
            setOpenDrawer(true)
        }
        else {
            toast.error("Select Challan Party", {
                "position": "top-center"
            })
        }
    }
    const handleSelChallan = (data) => {
        setSelectedChallan(data)
        funFilterChalData('CHALLAN_DETAIL', null, data)
        // }
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />
    }

    return (
        <div>
            <MainContainer pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel} `}
                breadcrumbs={["Purchase", entryLabel]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }} >

                <Card shadow="sm" className="mb-3 w-full">

                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            <div>
                                {
                                    Object.keys(inputBoxes).map((key, ind) => (
                                        <div key={key + ind}>
                                            <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 items-center mb-2 `}>
                                                {
                                                    inputBoxes[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <Select
                                                                name={item?.name}
                                                                placeholder="--select--"
                                                                label={item?.placeholder}
                                                                labelPlacement="outside"
                                                                selectionMode="single"
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                items={item.data ? item.data : []}
                                                                isVirtualized
                                                                onChange={(e) => handleChange(e, item.name)}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                selectedKeys={[String(formData[item.name])]}
                                                            >
                                                                {(list) => {
                                                                    return (
                                                                        <SelectItem key={list[item.itemkey]}>
                                                                            {list[item.itemvalue]}
                                                                        </SelectItem>
                                                                    );
                                                                }}
                                                            </Select>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            <>
                                                                <Autocomplete
                                                                    size="md"
                                                                    name={item.name}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    label={item?.placeholder}
                                                                    eventResizeFeature={true}
                                                                    selectionMode="single"
                                                                    showScrollIndicators={true}
                                                                    labelPlacement={"outside"}
                                                                    placeholder={item.placeholder}
                                                                    isRequired={item.isrequired}
                                                                    isLoading={isLoadingData}
                                                                    className="max-w-23"
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                    isClearable={false}
                                                                    isVirtualized
                                                                    defaultItems={
                                                                        item.data ? item.data : []
                                                                    }
                                                                    onSelectionChange={(e) =>
                                                                        handleAutoCompleteChange(e, "", item.name)
                                                                    }
                                                                    color={item.id == formField.acId ? "success" : item.id == formField.partyId ? "primary" : ""}
                                                                    //onChange={handleFormSelectionChange}
                                                                    selectedKey={formData[item.name]}
                                                                >
                                                                    {(list) => (


                                                                        <AutocompleteItem

                                                                            key={list[item.itemkey]}
                                                                        >
                                                                            {list[item.itemvalue]}
                                                                        </AutocompleteItem>
                                                                    )}
                                                                </Autocomplete>
                                                                {selTradeOf == 'Y' && modeSettingParams && modeSettingParams?.Visibility && modeSettingParams?.Visibility?.autoChallanEntry
                                                                    && item.id == formField.deliveryId ?
                                                                    <Chip size="md" color="warning" radius="sm"
                                                                        className="mt-5 cursor-pointer" variant="shadow"
                                                                        onClick={handleShowChallan}
                                                                    >Challan</Chip>
                                                                    : ""}
                                                            </>

                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <div className=" w-full flex items-center">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        label={item.placeholder}
                                                                        views={["day", "month", "year"]}
                                                                        format="DD/MM/YYYY"
                                                                        value={
                                                                            formData[item.name]
                                                                                ? dayjs(formData[item.name])
                                                                                : formData[item.name]
                                                                        }
                                                                        onChange={(newValue) => handleDateChange(newValue, item.name)}

                                                                        className="w-full"

                                                                        slotProps={{
                                                                            textField: { size: "small", required: item.isrequired },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        ) : (
                                                            <Input
                                                                type={item.type}
                                                                name={item.name}
                                                                //aria-label={item.placeholder}
                                                                placeholder={item.placeholder}
                                                                label={item.placeholder}
                                                                labelPlacement="outside"
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                isRequired={item.isrequired}
                                                                value={formData[item.name]}
                                                                variant="bordered"
                                                                onChange={(e) => handleChange(e, item.name)}
                                                                //  readOnly={item.name == formField.voucherNo ? true : false}
                                                                size={"md"}
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                            ></Input>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>

                                    ))
                                }
                                <Drawer open={openDrawer}
                                    onClose={toggleDrawer(false)} anchor={"right"}  >
                                    <div>
                                        <div onClick={toggleDrawer(false)} className="absolute right-0  ">
                                            <FontAwesomeIcon className="text-rose-600  cursor-pointer text-3xl" icon={faSquareXmark} />
                                        </div>
                                        {modeSettingParams && modeSettingParams.Visibility.autoChallanEntry ? (
                                            <div>
                                                <div className="text-center  shadow border-b-2 text-sm font-semibold uppercase text-red-700 p-2" >Yarn Purchase Challan List</div>
                                                {
                                                    partyChallanData && partyChallanData.length > 0 ? (
                                                        <ChallanList data={partyChallanData} handleSelChallan={handleSelChallan} />
                                                    ) : "Challan Not Found"
                                                }
                                            </div>) : (
                                            <div>
                                                <div className="text-center shadow border-b-2 text-sm font-semibold uppercase text-red-700 p-2" > {`  ${selTradeOf == 'C' ? "Gray" : "Yarn"} Purchase Challan Entry`}  </div>
                                                {inwardItemData && inwardItemData.length > 0 ?
                                                    <div className={`${isMobile ? "w-80  overflow-scroll" : ""} mx-5`}>
                                                        <InwardItemsEntry tradeOf={selTradeOf}
                                                            settingMode={selTradeOf == 'Y' ?
                                                                ENUM_MOD_NAME.YarnPurchaseCarton : ENUM_MOD_NAME.GrayPurchaseTakaEntry
                                                            }
                                                            inwardItemData={selInwardItemsData} handleSelectedInwardItem={handleSelectedInwardItem} />
                                                    </div>
                                                    : <h2 className="text-center text-pink-700 p-5   m-10 bg-rose-50" >Data not found</h2>}


                                            </div>

                                        )
                                        }
                                    </div>
                                </Drawer>
                                {/* dynamic grid */}
                                {/* // <div> */}
                                {msg && msg.length > 0 ? <div className="text-rose-700 text-center"> {msg}</div> : ""}
                                <div className="flex justify-between">
                                    <Button size="sm" color="success" className="text-white" startContent={<FontAwesomeIcon color="white" icon={faPlus} />} variant="shadow" onPress={handleAddRow}>
                                        ADD ITEM
                                    </Button>
                                </div>

                                {rows && rows?.length > 0 ? (
                                    //150+ style={{ height:50+ Number(rows.length * 51), overflow: "auto" }}
                                    <div style={{ height: 45 + Number(rows.length * 51), overflow: "auto" }} >
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            hideFooterPagination={true}
                                            hideFooter={true}
                                            columnHeaderHeight={35}
                                            rowHeight={45}
                                            disableColumnSorting={true}
                                            disableColumnMenu={true}
                                            columnVisibilityModel={appType == ENUM_APP_TYPE.TEXTTILE ? {
                                                orderNo: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.orderNo] : true, //getModVisiblity(ENUM_MOD_PARAMETER.GridOrder, modSetting),
                                                itemDetail: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.itemDetail] : true,  //getModVisiblity(ENUM_MOD_PARAMETER.GridItemDet, modSetting),
                                                cut: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.cut] : true,// getModVisiblity(ENUM_MOD_PARAMETER.GridCut, modSetting),
                                                meter: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.meter] : true,// getModVisiblity(ENUM_MOD_PARAMETER.Meter, modSetting),
                                                weight: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.weight] : true,// getModVisiblity(ENUM_MOD_PARAMETER.Weight, modSetting),
                                                discPer: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.discPer] : true,// getModVisiblity(ENUM_MOD_PARAMETER.Discount, modSetting),
                                                discAmt: modSetting && modSetting.length > 0 ? modeSettingParams?.Visibility[RowsField.discAmt] : true,// getModVisiblity(ENUM_MOD_PARAMETER.Discount, modSetting),

                                            } : {}}

                                        />
                                    </div>
                                ) : (
                                    ""
                                )}

                                {/* // </div> */}
                                {/* end dynamic grid */}
                                {/* /tax calculation section */}
                                <div>
                                    <div className="flex  items-top gap-2 mt-7">
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Gross Amount"
                                            labelPlacement="outside"
                                            value={gross_Amount}
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Discount"
                                            labelPlacement="outside"
                                            value={total_disc}
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="text"
                                            label="Remarks"
                                            labelPlacement="outside"
                                            placeholder="Remarks"
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            name="remarks"
                                            value={formData.remarks}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="flex  items-top gap-2 mt-3">
                                        <Input
                                            size="sm"
                                            type="number"
                                            label={!isStPerDisable ? "CGST Tax" : "IGST Tax"}
                                            labelPlacement="outside"
                                            value={total_GSTtax}
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="SGST Tax"
                                            labelPlacement="outside"
                                            value={!isStPerDisable ? total_SGSTtax : "0"}
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Total Tax"
                                            labelPlacement="outside"
                                            value={total_Tax}
                                            className="max-w-25 "
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                    </div>
                                    {/* //getModVisiblity(ENUM_MOD_PARAMETER.Tds, modSetting)  */}
                                    {modeSettingParams?.Visibility?.tds ?
                                        (<div className="flex  items-top gap-2 mt-3">
                                            <Input
                                                size="sm"
                                                type="text"
                                                label="TDS %"
                                                labelPlacement="outside"
                                                className="max-w-25"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                value={setTdsPer}
                                                onChange={(e) => { funValidateNoInput(e.target.value) ? setSetTdsPer(e.target.value) : setSetTdsPer(0) }}
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">₹</span>
                                                    </div>
                                                }
                                            />
                                            <Input
                                                size="sm"
                                                type="number"
                                                label="TDS Amount"
                                                labelPlacement="outside"
                                                className="max-w-25"
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}
                                                disabled={true}
                                                value={total_TdsAmt}
                                                startContent={
                                                    <div className="pointer-events-none flex items-center">
                                                        <span className="text-default-400 text-small">₹</span>
                                                    </div>
                                                }
                                            />
                                            <Autocomplete
                                                size="sm"
                                                id="tdsAc"
                                                label="TDS Ac."
                                                labelPlacement="outside"
                                                isVirtualized
                                                placeholder="--Select--"
                                                className="max-w-25"
                                                isLoading={isLoadingData}
                                                classNames={{
                                                    label: "text-xs text-black font-bold",
                                                }}

                                                defaultItems={
                                                    masterData && masterData.tdsMaster
                                                        ? masterData.tdsMaster
                                                        : []
                                                }
                                                onSelectionChange={(e) =>
                                                    handleFormSelectionChange(e, "tdsAc")
                                                }
                                                selectedKey={formData.tdsAc}
                                            >
                                                {(item) => (
                                                    <AutocompleteItem key={item.Party_Id}>
                                                        {item.Party_Name}
                                                    </AutocompleteItem>
                                                )}
                                            </Autocomplete>
                                        </div>) : ""}
                                    <div className="flex  items-top gap-2 mt-3">
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Net Amount"
                                            labelPlacement="outside"
                                            value={net_Amount}
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="text"
                                            label="TCS %"
                                            labelPlacement="outside"
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            value={setTcsPer}
                                            onChange={(e) => { funValidateNoInput(e.target.value) ? setSetTcsPer(e.target.value) : setSetTcsPer(0) }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="TCS Amount"
                                            labelPlacement="outside"
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            disabled={true}
                                            value={total_TcsAmt}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                    </div>
                                    <div className="flex  items-top gap-2 mt-7 ">
                                        <Input
                                            size="sm"
                                            type="number"
                                            label="Amount"
                                            placeholder="Amount"
                                            value={Number(net_Amount ?? 0) + Number(total_TcsAmt ?? 0)}
                                            className="max-w-25"
                                            variant="flat"
                                            color="success"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">₹</span>
                                                </div>
                                            }
                                        />
                                        <Input
                                            size="sm"
                                            type="text"
                                            name={formField.dueDays}
                                            label="Due Days"
                                            placeholder="Due Days"
                                            value={formData[formField.dueDays]}
                                            className="max-w-25"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            variant="flat"
                                            color="warning"
                                            onChange={(e) => funValidateNoInput(e.target.value) ? handleChange(e, formField.dueDays)
                                                : setFormData({ ...formData, [formField.dueDays]: 0 })}

                                        />


                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label={"Due Date"}
                                                views={["day", "month", "year"]}
                                                format="DD/MM/YYYY"
                                                value={
                                                    formData[formField.dueDate]
                                                        ? dayjs(formData[formField.dueDate])
                                                        : formData[formField.dueDate]
                                                }
                                                onChange={(newValue) => {
                                                    setFormData((prev) => {
                                                        return {
                                                            ...prev,
                                                            [formField.dueDate]:
                                                                dayjs(newValue).format("YYYY-MM-DD"),

                                                        };
                                                    });
                                                }}
                                                //isRequired={item.required}
                                                className="w-full "
                                                slotProps={{
                                                    textField: { size: "small", required: false },
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </div>
                                {/* /end tax calculation section */}

                                <div className="justify-center flex gap-5 mt-20">
                                    <Button
                                        color="primary"
                                        type="submit"
                                        size="md"
                                        variant="shadow"
                                        startContent={<FontAwesomeIcon icon={faSave} />}
                                    >
                                        Submit
                                    </Button>
                                    <Button
                                        color="danger"
                                        variant="shadow"
                                        size="md"
                                        onPress={handleClickPrev}
                                        startContent={<FontAwesomeIcon icon={faCancel} />}
                                    >
                                        Cancel
                                    </Button>
                                </div>

                                {/* </div>

                                ) */}



                            </div>
                        </CardBody>
                    </form>
                </Card>
            </MainContainer>
        </div>
    )
}
export default CreatePurchaseEntry